import { render } from "./ListeCleTypeNotificationPage.vue?vue&type=template&id=4513a744&ts=true"
import script from "./ListeCleTypeNotificationPage.vue?vue&type=script&lang=ts"
export * from "./ListeCleTypeNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__